import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// CRA's generated serviceWorker.js is deliberately NOT imported — see the note
// at the bottom of this file. Fair Tracker registers its own worker.


// Prevent pinch zoom gestures
document.addEventListener(
  'touchstart',
  function (e) {
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  },
  { passive: false }
);

// Prevent double-tap to zoom
let lastTouchEnd = 0;
document.addEventListener(
  'touchend',
  function (e) {
    const now = new Date().getTime();
    if (now - lastTouchEnd <= 300) {
      e.preventDefault();
    }
    lastTouchEnd = now;
  },
  { passive: false }
);

document.addEventListener('gesturestart', function (e) {
  e.preventDefault();
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// DO NOT call serviceWorker.unregister() here.
//
// CRA's unregister() resolves `navigator.serviceWorker.ready` and unregisters
// whatever worker is active — which would tear down the Fair Tracker worker on
// every page load, silently removing the offline capability that app depends
// on (it has to cold-boot in a Canton Fair hall with no connection).
//
// Fair Tracker registers its own worker from
// components/fairTracker/pwa/swRegister.js, and only when someone actually
// opens that app, so no other BeeNexa user gets one. CRA's generated
// serviceWorker.js is left unused.
//
// To remove the worker from a device, use unregister() from
// components/fairTracker/pwa/swRegister.js instead.
